import { nanoid } from 'nanoid';

import {
  CLEAR_DEFAULT_PAGES,
  ADD_DEFAULT_PAGE,
  SET_DEFAULT_PAGES,
  REMOVE_DEFAULT_PAGE,
  REORDER_DEFAULT_PAGE,
  SET_FORM_DATA,
  CLEAR_PAGE_LIBRARY,
  ADD_LIBRARY_PAGE,
  REMOVE_LIBRARY_PAGE,
  SET_LIBRARY_PAGES,
  REORDER_LIBRARY_PAGE
} from '../actions';

export default function (state = {}, action) {
  switch (action.type) {
  case SET_FORM_DATA:
    return { ...state, ...action.payload };

  case ADD_DEFAULT_PAGE:
    return {
      ...state,
      defaultPages: [
        ...state.defaultPages || [],
        { id: action.payload.id, key: nanoid(), template_type: action.payload.templateType }
      ]
    };

  case SET_DEFAULT_PAGES:
    return {
      ...state,
      defaultPages: action.payload.map(page => ({
        id: page.id,
        key: nanoid(),
        template_type: page.template_type
      }))
    };

  case REMOVE_DEFAULT_PAGE: {
    const newDefaultPages = [...state.defaultPages];
    newDefaultPages.splice(action.payload, 1);
    return { ...state, defaultPages: newDefaultPages };
  }

  case REORDER_DEFAULT_PAGE: {
    const { fromIndex, toIndex } = action.payload;
    const newDefaultPages = [...state.defaultPages];
    const page = newDefaultPages[fromIndex];
    newDefaultPages[fromIndex] = newDefaultPages[toIndex];
    newDefaultPages[toIndex] = page;

    return { ...state, defaultPages: newDefaultPages };
  }

  case REORDER_LIBRARY_PAGE: {
    const { fromIndex, toIndex } = action.payload;
    const newLibraryPages = [...state.availablePageTemplateTreeIds];
    const page = newLibraryPages[fromIndex];
    newLibraryPages[fromIndex] = newLibraryPages[toIndex];
    newLibraryPages[toIndex] = page;

    return { ...state, availablePageTemplateTreeIds: newLibraryPages };
  }

  case CLEAR_DEFAULT_PAGES:
    return { ...state, defaultPages: null };

  case CLEAR_PAGE_LIBRARY:
    return { ...state, availablePageTemplateTreeIds: null };

  case ADD_LIBRARY_PAGE:
    return {
      ...state,
      availablePageTemplateTreeIds: [
        ...(state.availablePageTemplateTreeIds || []),
        { id: action.payload.id, key: nanoid(), template_type: action.payload.templateType }
      ]
    };

  case REMOVE_LIBRARY_PAGE: {
    const { id, templateType } = action.payload;
    const newAvailablePages = state.availablePageTemplateTreeIds.filter(
      page => !(page.id === id && page.template_type === templateType)
    );

    // remove page from page defaults if it's being removed from the page library
    let updatedDefaultPages = state.defaultPages;
    if (state.defaultPages !== null) {
      updatedDefaultPages = state.defaultPages.filter(
        page => !(page.id === id && page.template_type === templateType)
      );
    }

    return {
      ...state,
      availablePageTemplateTreeIds: newAvailablePages,
      defaultPages: updatedDefaultPages
    };
  }

  case SET_LIBRARY_PAGES:
    return { ...state, availablePageTemplateTreeIds: action.payload };

  default:
    return state;
  }
}
